import React from 'react';
import { createRoot } from 'react-dom/client';
import HelloReact from './react/HelloReact.jsx';
import HelloWorld from './react/HelloWorld.jsx';

// Array of components to render within react-root
const componentsToRender = [
    {
        id: 'hello-react',
        component: HelloReact
    },
    {
        id: 'hello-world',
        component: HelloWorld
    }

    // Add more components here as needed
    // {
    //     id: 'another-component',
    //     component: AnotherComponent
    // }
];

function renderComponents() {
    const reactRoot = document.getElementById('react-root');
    
    if (reactRoot) {
        componentsToRender.forEach(({ id, component: Component }) => {
            const element = reactRoot.querySelector(`#${id}`);
            
            if (element) {
                try {
                    const root = createRoot(element);
                    root.render(<Component />);
                } catch (error) {
                    console.error(`Error rendering ${id} component:`, error);
                }
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', renderComponents);
setTimeout(renderComponents, 100);
